<template lang="pug">
  #Facturas
    Header
    div.fact-breadcrumb
      div.fact-breadcrumb-inner
        a.fact-bread-link(href='/') Inicio
        span.fact-bread-sep /
        span.fact-bread-cur Historial de facturas
    div.fact-page
      div.fact-container
        div.fact-header
          div.fact-title-wrap
            v-icon.fact-title-icon(color='#0F4DFF') mdi-file-document-multiple
            span.fact-title Mis Facturas
            span.fact-count(v-if='totalF') {{facturas.length}} de {{totalF}}
          div.fact-header-actions
            v-text-field.fact-search(v-model='search' placeholder='Buscar por número...' dense outlined hide-details append-icon='mdi-magnify' @click:append='initialize()' style='min-width:200px;' clearable)
            v-btn(small depressed color='#1d6f42' dark @click='exportarExcelTodas()' :disabled='facturas.length === 0')
              v-icon(small left) mdi-microsoft-excel
              | Excel todas
            v-btn(small depressed color='#1d6f42' dark @click='exportarExcelSeleccionadas()' :disabled='seleccionadas.length === 0')
              v-icon(small left) mdi-microsoft-excel
              | Excel ({{seleccionadas.length}})
        v-tabs.fact-tabs(v-model='tab' color='#0F4DFF' background-color='transparent')
          v-tab
            v-icon(left small) mdi-format-list-bulleted
            | Lista
          v-tab
            v-icon(left small) mdi-calendar-month
            | Calendario de vencimientos
        div.fact-deuda-banner(v-if='saldoDeudor > 0 && tab === 0')
          v-icon(color='white' size='20') mdi-alert-circle
          span Total deuda pendiente:
          span.fact-deuda-monto ${{saldoDeudor}}
        div.fact-table-wrap(v-if='tab === 0')
          div.fact-table-head(v-if='facturas.length > 0')
            div.fact-check-cell
              v-checkbox(v-model='todosSeleccionados' hide-details dense @change='toggleTodos' style='margin:0;padding:0;')
            span Nro. Factura
            span Emisión
            span Vencimiento
            span Saldo
            span Total
            span
          div.fact-skeleton(v-if='loading && facturas.length === 0')
            v-skeleton-loader(v-for='i in 5' :key='i' type='list-item-two-line' style='margin-bottom:8px;')
          div.fact-empty(v-if='!loading && facturas.length === 0')
            v-icon(size='48' color='#c0c8d8') mdi-file-document-outline
            span No tienes facturas registradas
          div.fact-row(v-for='(item, i) in facturas' :key='i' :class="{ 'fact-row-alt': i % 2 !== 0, 'fact-row-sel': seleccionadas.includes(item.nro_doc) }")
            div.fact-check-cell
              v-checkbox(v-model='seleccionadas' :value='item.nro_doc' hide-details dense style='margin:0;padding:0;')
            div.fact-cell
              span.fact-label Nro.
              span.fact-nro {{item.nro_doc}}
            div.fact-cell
              span.fact-label Emisión
              span {{item.fec_emis | moment('DD/MM/YYYY')}}
            div.fact-cell
              span.fact-label Vencimiento
              span {{item.fec_venc | moment('DD/MM/YYYY')}}
            div.fact-cell
              span.fact-label Saldo
              span.fact-saldo-pendiente(v-if='item.saldo > 0') ${{item.saldo}}
              span.fact-saldo-ok(v-else) ${{item.saldo}}
            div.fact-cell
              span.fact-label Total
              span.fact-total ${{item.total_neto}}
            div.fact-cell.fact-cell-action
              v-btn(small depressed color='#0F4DFF' dark @click='editItem(item)')
                v-icon(small left) mdi-eye
                | Ver
        div.fact-load-more(v-if='tab === 0 && facturas.length > 0 && facturas.length !== totalF')
          v-btn(depressed color='#0F4DFF' dark :loading='loading' @click='verM()')
            v-icon(left) mdi-chevron-down
            | Cargar más
        div.fact-cal-wrap(v-if='tab === 1')
          div.fact-cal-header
            v-btn(icon @click='calPrev()')
              v-icon mdi-chevron-left
            span.fact-cal-title {{calTitleStr}}
            v-btn(icon @click='calNext()')
              v-icon mdi-chevron-right
            v-btn(small depressed @click='calHoy()' style='margin-left:12px;text-transform:none;') Hoy
          div.fact-cal-grid
            div.fact-cal-dow(v-for='d in ["Dom","Lun","Mar","Mié","Jue","Vie","Sáb"]' :key='d') {{d}}
            div.fact-cal-cell(v-for='cell in calCells' :key='cell.key' :class='{\'fact-cal-empty\': !cell.day, \'fact-cal-today\': cell.isToday, \'fact-cal-has\': cell.facturas.length > 0}')
              span.fact-cal-day(v-if='cell.day') {{cell.day}}
              div.fact-cal-event(v-for='f in cell.facturas' :key='f.nro_doc' @click='editItem(f)')
                span.fact-cal-event-nro {{f.nro_doc.trim()}}
                span.fact-cal-event-saldo ${{f.saldo}}
    v-dialog(v-model='dialog' persistent max-width='680px' scrollable)
      v-card(flat style='border-radius:12px;overflow:hidden;')
        div.fm-top-bar
        v-card-text(style='padding:0;')
          div.fm-body
            div.fm-header
              img.fm-logo(src='../assets/imgFerco/logo2.png')
              div.fm-header-right
                div.fm-badge FACTURA
                div.fm-nro {{form.nro_doc}}
            div.fm-meta-grid
              div.fm-meta-item
                div.fm-meta-label Fecha emisión
                div.fm-meta-val(v-if='form.fec_emis') {{form.fec_emis | moment('DD/MM/YYYY')}}
                div.fm-meta-val(v-else) —
              div.fm-meta-item
                div.fm-meta-label Fecha vencimiento
                div.fm-meta-val(v-if='form.fec_venc') {{form.fec_venc | moment('DD/MM/YYYY')}}
                div.fm-meta-val(v-else) —
              div.fm-meta-item(v-if='form.vendedor')
                div.fm-meta-label Vendedor
                div.fm-meta-val {{form.vendedor}}
              div.fm-meta-item
                div.fm-meta-label Saldo pendiente
                div.fm-meta-val(:style="form.saldo > 0 ? 'color:#e53e3e;font-size:18px;font-weight:800;' : 'color:#38a169;font-weight:700;'") ${{form.saldo || '0.00'}}
          div.fm-table
            div.fm-table-head
              div Producto
              div.fm-col-sm Código
              div.fm-col-sm Modelo
              div.fm-col-sm Ref
              div Cantidad
              div Monto
            div.fm-table-body
              div.fm-table-row(v-for='(item, i) in (form.items && form.items.length ? form.items : form.renglones)' :key='i' :class="{ 'fm-row-alt': i % 2 !== 0 }")
                div.fm-col-name {{item.art_des || item.des_art}}
                div.fm-col-sm.fm-col-meta {{ item.co_art ? (Array.isArray(item.co_art) ? item.co_art[0] : item.co_art).trim() : '—' }}
                div.fm-col-sm.fm-col-meta {{ item.modelo ? (Array.isArray(item.modelo) ? item.modelo[0] : item.modelo) : '—' }}
                div.fm-col-sm.fm-col-meta {{ item.ref ? (Array.isArray(item.ref) ? item.ref[0] : item.ref) : '—' }}
                div.fm-col-qty
                  span {{item.total_art}}
                div.fm-col-price ${{item.reng_neto}}
          div.fm-total-bar
            span Total
            span ${{form.total_neto}}
        v-divider
        v-card-actions(style='padding:12px 16px;')
          v-btn(depressed color='#c0392b' dark small @click='exportarPDF()' style='text-transform:none;letter-spacing:0;border-radius:8px;')
            v-icon(left small) mdi-file-pdf-box
            | PDF
          v-btn(depressed color='#1d6f42' dark small @click='exportarExcelFactura()' style='text-transform:none;letter-spacing:0;border-radius:8px;margin-left:8px;')
            v-icon(left small) mdi-microsoft-excel
            | Excel
          v-spacer
          v-btn(depressed @click='close' style='text-transform:none;letter-spacing:0;border-radius:8px;')
            v-icon(left small) mdi-close
            | Cerrar
    v-overlay(:value='loading2' z-index='999')
      div.fact-loading-overlay
        v-progress-circular(indeterminate color='white' size='48')
        span Cargando...
    Footer
</template>

<script>
import Footer from '@/components/Footer.vue'
import Header from '@/components/Header.vue'
import Api from '@/services/methods'
import Swal from 'sweetalert2/dist/sweetalert2.min.js'
import { mapState, mapActions } from 'vuex'
import { serverImg } from '@/services/environment'
import * as XLSX from 'xlsx'
export default {
  name: 'Facturas',
  components: {
    Header,
    Footer
  },
  data () {
    return {
      search: '',
      tab: 0,
      calYear: new Date().getFullYear(),
      calMonth: new Date().getMonth(),
      loading: false,
      loading2: false,
      saldoDeudor: 0,
      skip: 0,
      form: {
        fec_emis: '',
        fec_venc: '',
        items: [],
        renglones: [],
        nro_doc: '',
        saldo: 0,
        total_neto: 0,
        vendedor: ''
      },
      totalF: '',
      dialog: false,
      defaultForm: {
        fec_emis: '',
        fec_venc: '',
        items: [],
        renglones: [],
        nro_doc: '',
        saldo: 0,
        total_neto: 0,
        vendedor: ''
      },
      pantalla: screen.width,
      ruta: serverImg,
      facturas: [],
      facturasVenc: [],
      seleccionadas: [],
      todosSeleccionados: false
    }
  },
  computed: {
    calTitleStr () {
      const meses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']
      return meses[this.calMonth] + ' ' + this.calYear
    },
    calCells () {
      const year = this.calYear
      const month = this.calMonth
      const today = new Date()
      const firstDay = new Date(year, month, 1).getDay()
      const daysInMonth = new Date(year, month + 1, 0).getDate()
      const cells = []
      for (let i = 0; i < firstDay; i++) cells.push({ key: 'e' + i, day: null, isToday: false, facturas: [] })
      for (let d = 1; d <= daysInMonth; d++) {
        const isToday = today.getDate() === d && today.getMonth() === month && today.getFullYear() === year
        const dayFacturas = this.facturasVenc.filter(f => {
          if (!f.saldo || f.saldo <= 0) return false
          const fv = new Date(f.fec_venc)
          return fv.getDate() === d && fv.getMonth() === month && fv.getFullYear() === year
        })
        cells.push({ key: d, day: d, isToday, facturas: dayFacturas })
      }
      return cells
    }
  },
  watch: {
    search () {
      clearTimeout(this._searchTimer)
      this._searchTimer = setTimeout(() => { this.initialize() }, 400)
    }
  },
  created () {
    this.initialize()
    document.documentElement.scrollTop = 0
  },
  methods: {
    calcularDeud () {
      if (this.facturas.length > 0) {
        let acum = 0
        for (let i = 0; i < this.facturas.length; i++) {
          acum = acum + this.facturas[i].saldo
        }
        return acum
      } else {
        return 0
      }
    },
    comparar (data) {
      if ((data + 1) === this.form.items.length) {
        return true
      } else {
        return false
      }
    },
    par (data) {
      if (data % 2 === 0) {
        return false
      } else {
        return true
      }
    },
    editItem (item) {
      Object.keys(this.form).forEach(key => {
        if (item[key] !== undefined) this.form[key] = item[key]
      })
      this.form._id = item._id
      this.dialog = true
    },
    close () {
      this.form = Object.assign({}, this.defaultForm)
      this.dialog = false
    },
    async exportarPDF () {
      const { jsPDF } = await import('jspdf')
      const { default: autoTable } = await import('jspdf-autotable')
      const doc = new jsPDF()
      const f = this.form
      // Logo
      const logoUrl = require('@/assets/imgFerco/logo2.png')
      const img = new Image()
      img.src = logoUrl
      await new Promise(resolve => { img.onload = resolve; img.onerror = resolve })
      try { doc.addImage(img, 'PNG', 14, 10, 50, 18) } catch (e) {}
      // Header derecho
      doc.setFillColor(15, 77, 255)
      doc.rect(130, 10, 65, 20, 'F')
      doc.setFontSize(11)
      doc.setTextColor(255, 255, 255)
      doc.setFont('helvetica', 'bold')
      doc.text('FACTURA', 162, 18, { align: 'center' })
      doc.setFontSize(10)
      doc.text(f.nro_doc || '', 162, 26, { align: 'center' })
      // Línea separadora
      doc.setDrawColor(15, 77, 255)
      doc.setLineWidth(0.5)
      doc.line(14, 32, 195, 32)
      // Meta
      doc.setFontSize(9)
      doc.setTextColor(80, 80, 80)
      doc.setFont('helvetica', 'normal')
      const emis = f.fec_emis ? this.$moment(f.fec_emis).format('DD/MM/YYYY') : '-'
      const venc = f.fec_venc ? this.$moment(f.fec_venc).format('DD/MM/YYYY') : '-'
      doc.text('Fecha emisión:', 14, 40)
      doc.setTextColor(30, 30, 30)
      doc.setFont('helvetica', 'bold')
      doc.text(emis, 50, 40)
      doc.setTextColor(80, 80, 80)
      doc.setFont('helvetica', 'normal')
      doc.text('Fecha vencimiento:', 14, 47)
      doc.setTextColor(30, 30, 30)
      doc.setFont('helvetica', 'bold')
      doc.text(venc, 55, 47)
      if (f.vendedor) {
        doc.setTextColor(80, 80, 80)
        doc.setFont('helvetica', 'normal')
        doc.text('Vendedor:', 14, 54)
        doc.setTextColor(30, 30, 30)
        doc.setFont('helvetica', 'bold')
        doc.text(f.vendedor, 40, 54)
      }
      // Saldo
      const saldoColor = f.saldo > 0 ? [220, 53, 69] : [40, 167, 69]
      doc.setTextColor(...saldoColor)
      doc.setFont('helvetica', 'bold')
      doc.setFontSize(10)
      doc.text('Saldo: $' + (f.saldo || '0.00'), 160, 40, { align: 'right' })
      // Tabla
      const lista = (f.items && f.items.length) ? f.items : (f.renglones || [])
      const rows = lista.map(i => [i.art_des || i.des_art, i.total_art, '$' + i.reng_neto])
      autoTable(doc, {
        startY: 60,
        head: [['Producto', 'Cantidad', 'Monto']],
        body: rows,
        styles: { fontSize: 9, cellPadding: 4 },
        headStyles: { fillColor: [15, 77, 255], textColor: 255, fontStyle: 'bold' },
        alternateRowStyles: { fillColor: [248, 249, 251] },
        columnStyles: { 1: { halign: 'center' }, 2: { halign: 'right' } }
      })
      const finalY = doc.lastAutoTable.finalY + 6
      doc.setFillColor(241, 244, 249)
      doc.rect(130, finalY, 65, 10, 'F')
      doc.setFontSize(10)
      doc.setFont('helvetica', 'bold')
      doc.setTextColor(15, 77, 255)
      doc.text('Total: $' + (f.total_neto || '0.00'), 192, finalY + 7, { align: 'right' })
      doc.save('Factura-' + (f.nro_doc || 'detalle') + '.pdf')
    },
    exportarExcelFactura () {
      const f = this.form
      const lista = (f.items && f.items.length) ? f.items : (f.renglones || [])
      const rows = lista.map(i => ({
        Código: i.co_art ? (Array.isArray(i.co_art) ? i.co_art[0] : i.co_art).trim() : '',
        Producto: i.art_des ? (Array.isArray(i.art_des) ? i.art_des[0] : i.art_des) : (i.des_art || ''),
        Modelo: i.modelo ? (Array.isArray(i.modelo) ? i.modelo[0] : i.modelo) : '',
        Ref: i.ref ? (Array.isArray(i.ref) ? i.ref[0] : i.ref) : '',
        Cantidad: i.total_art,
        Monto: i.reng_neto
      }))
      rows.push({ Código: '', Producto: '', Modelo: '', Ref: '', Cantidad: 'TOTAL', Monto: f.total_neto })
      const ws = XLSX.utils.json_to_sheet(rows)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, 'Factura')
      XLSX.writeFile(wb, 'Factura-' + (f.nro_doc || 'detalle') + '.xlsx')
    },
    toggleTodos (val) {
      this.seleccionadas = val ? this.facturas.map(f => f.nro_doc) : []
    },
    exportarExcelSeleccionadas () {
      const selected = this.facturas.filter(f => this.seleccionadas.includes(f.nro_doc))
      const rows = []
      selected.forEach(f => {
        const lista = (f.items && f.items.length) ? f.items : (f.renglones || [])
        lista.forEach(i => {
          rows.push({
            'Nro. Factura': f.nro_doc,
            Emisión: f.fec_emis ? this.$moment(f.fec_emis).format('DD/MM/YYYY') : '-',
            Vencimiento: f.fec_venc ? this.$moment(f.fec_venc).format('DD/MM/YYYY') : '-',
            Código: i.co_art ? (Array.isArray(i.co_art) ? i.co_art[0] : i.co_art).trim() : '',
            Producto: i.art_des ? (Array.isArray(i.art_des) ? i.art_des[0] : i.art_des) : (i.des_art || ''),
            Modelo: i.modelo ? (Array.isArray(i.modelo) ? i.modelo[0] : i.modelo) : '',
            Ref: i.ref ? (Array.isArray(i.ref) ? i.ref[0] : i.ref) : '',
            Cantidad: i.total_art,
            Monto: i.reng_neto
          })
        })
        rows.push({ 'Nro. Factura': f.nro_doc, Emisión: '', Vencimiento: '', Código: '', Producto: '', Modelo: '', Ref: '', Cantidad: 'TOTAL', Monto: f.total_neto })
        rows.push({})
      })
      const ws = XLSX.utils.json_to_sheet(rows)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, 'Facturas')
      XLSX.writeFile(wb, 'Facturas-seleccionadas.xlsx')
    },
    exportarExcelTodas () {
      const rows = this.facturas.map(f => ({
        'Nro. Factura': f.nro_doc,
        'Fecha Emisión': f.fec_emis ? this.$moment(f.fec_emis).format('DD/MM/YYYY') : '-',
        'Fecha Vencimiento': f.fec_venc ? this.$moment(f.fec_venc).format('DD/MM/YYYY') : '-',
        Saldo: f.saldo,
        Total: f.total_neto
      }))
      const ws = XLSX.utils.json_to_sheet(rows)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, 'Facturas')
      XLSX.writeFile(wb, 'Facturas.xlsx')
    },
    buildQuery () {
      return 'busqueda=' + (this.search || '')
    },
    calPrev () {
      if (this.calMonth === 0) { this.calMonth = 11; this.calYear-- } else { this.calMonth-- }
    },
    calNext () {
      if (this.calMonth === 11) { this.calMonth = 0; this.calYear++ } else { this.calMonth++ }
    },
    calHoy () {
      this.calYear = new Date().getFullYear()
      this.calMonth = new Date().getMonth()
    },
    verM () {
      this.loading = true
      Api.get('web/facturas?skip=' + this.skip + '&' + this.buildQuery()).then(res => {
        for (let i = 0; i < res.data.length; i++) {
          this.facturas.push(res.data[i])
        }
        this.loading = false
        this.skip += 20
      }).catch(err => {
        this.loading = false
        console.log(err)
        Swal.fire(
          'Error inesperado',
          'Problemas de conexión, por favor inténtelo nuevamente.',
          'error'
        )
      })
    },
    initialize () {
      if (this.$store.state.fercoWeb.co_cli) {
        this.loading = true
        this.skip = 0
        Api.get('web/facturas?skip=0&' + this.buildQuery()).then(res => {
          this.facturas = res.data
          if (this.facturas && this.facturas.length > 0 && this.facturas[0].cliente && this.facturas[0].cliente.saldo_deudor != null) this.saldoDeudor = this.facturas[0].cliente.saldo_deudor.toFixed(2)
          this.skip = 20
          this.loading = false
        }).catch(err => {
          this.loading = false
          console.log(err)
        })
        Api.get('web/facturas/count?' + this.buildQuery()).then(res => {
          this.totalF = res.data
        })
        Api.get('web/facturas/vencimientos').then(res => {
          this.facturasVenc = res.data
        })
      }
    }
  }
}
</script>
<style lang="scss">
// Estilos del modal (fuera del scope de #Facturas porque v-dialog usa portal)
.fm-top-bar {
  height: 5px;
  background: linear-gradient(90deg, #0F4DFF, #4f8cff);
}
.fm-body {
  padding: 24px 28px 0;
}
.fm-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 20px;
}
.fm-logo {
  height: 40px;
  width: auto;
  max-width: 140px;
  object-fit: contain;
}
.fm-header-right { text-align: right; }
.fm-badge {
  display: inline-block;
  background: #0F4DFF;
  color: white;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 2px;
  padding: 3px 10px;
  border-radius: 4px;
  margin-bottom: 6px;
}
.fm-nro { font-size: 20px; font-weight: 800; color: #1a202c; }
.fm-meta-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px 20px;
  background: #f8f9fb;
  border-radius: 10px;
  padding: 16px;
  margin-bottom: 20px;
}
.fm-meta-item {
  .fm-meta-label { font-size: 10px; font-weight: 700; color: #a0aec0; text-transform: uppercase; letter-spacing: 0.5px; margin-bottom: 3px; }
  .fm-meta-val { font-size: 14px; font-weight: 600; color: #2d3748; }
}
.fm-status-badge {
  display: inline-block;
  font-size: 12px;
  font-weight: 700;
  padding: 3px 12px;
  border-radius: 20px;
  &.fm-status-debt { background: #fff0f0; color: #e53e3e; border: 1px solid #ffc5c5; }
  &.fm-status-paid { background: #f0fff4; color: #38a169; border: 1px solid #9ae6b4; }
}
.fm-table {
  border: 1px solid #eef0f4;
  border-radius: 10px;
  overflow: hidden;
  margin: 0 28px 20px;
}
.fm-col-sm {
  font-size: 12px;
  color: #4a5568;
}
.fm-col-meta {
  font-size: 12px;
  color: #718096;
}
.fm-table-head {
  display: grid;
  grid-template-columns: 2fr 80px 90px 80px 70px 90px;
  background: #f1f4f9;
  padding: 10px 16px;
  > div {
    font-size: 11px;
    font-weight: 700;
    color: #8a94a6;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    &:nth-child(5) { text-align: center; }
    &:nth-child(6) { text-align: right; }
  }
}
.fm-table-body { max-height: 280px; overflow-y: auto; }
.fm-table-row {
  display: grid;
  grid-template-columns: 2fr 80px 90px 80px 70px 90px;
  align-items: center;
  padding: 10px 16px;
  border-top: 1px solid #f1f4f9;
  &.fm-row-alt { background: #fafbfd; }
  .fm-col-name { font-size: 13px; color: #2d3748; font-weight: 500; line-height: 1.4; padding-right: 8px; }
  .fm-col-qty {
    text-align: center;
    span {
      display: inline-block;
      background: #eef0f4;
      color: #4a5568;
      font-size: 12px;
      font-weight: 700;
      border-radius: 20px;
      padding: 2px 10px;
    }
  }
  .fm-col-price { font-size: 13px; font-weight: 700; color: #1a202c; text-align: right; }
}
.fm-total-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 28px 24px;
  padding: 14px 20px;
  background: #f1f4f9;
  border-radius: 10px;
  span:first-child { font-size: 14px; font-weight: 700; color: #4a5568; }
  span:last-child { font-size: 22px; font-weight: 900; color: #0F4DFF; }
}

#Facturas {
  background: #f8f9fb;
  min-height: 100vh;

  .fact-breadcrumb {
    background: white;
    border-bottom: 1px solid #eef0f4;
    padding: 12px 24px;
    .fact-breadcrumb-inner { display: flex; align-items: center; gap: 8px; max-width: 1100px; margin: 0 auto; }
    .fact-bread-link { font-size: 13px; font-weight: 600; color: #0F4DFF; text-decoration: none; &:hover { text-decoration: underline; } }
    .fact-bread-sep { color: #c0c8d8; font-size: 13px; }
    .fact-bread-cur { font-size: 13px; font-weight: 600; color: #2d3748; }
  }

  .fact-page {
    max-width: 1100px;
    margin: 32px auto;
    padding: 0 16px;
  }

  .fact-container {
    background: white;
    border-radius: 16px;
    box-shadow: 0 2px 16px rgba(0,0,0,0.06);
    overflow: hidden;
  }

  .fact-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 16px;
    padding: 24px 28px 20px;
    border-bottom: 1px solid #eef0f4;
    .fact-title-wrap { display: flex; align-items: center; gap: 10px; }
    .fact-title-icon { opacity: 0.9; }
    .fact-title { font-size: 20px; font-weight: 700; color: #1a202c; }
    .fact-count { font-size: 13px; color: #8a94a6; background: #f1f4f9; border-radius: 20px; padding: 2px 10px; margin-left: 4px; }
    .fact-header-actions { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; }
  }

  .fact-deuda-banner {
    display: flex;
    align-items: center;
    gap: 10px;
    background: linear-gradient(90deg, #e53e3e, #c53030);
    color: white;
    padding: 12px 28px;
    font-size: 14px;
    font-weight: 500;
    .fact-deuda-monto { font-size: 18px; font-weight: 800; margin-left: 4px; }
  }

  .fact-table-wrap { padding: 0 0 8px; }

  .fact-table-head {
    display: grid;
    grid-template-columns: 36px 2fr 1.2fr 1.2fr 1fr 1fr 80px;
    padding: 12px 28px;
    background: #f8f9fb;
    border-bottom: 1px solid #eef0f4;
    span { font-size: 11px; font-weight: 700; color: #8a94a6; text-transform: uppercase; letter-spacing: 0.5px; }
    @media (max-width: 700px) { display: none; }
  }

  .fact-skeleton { padding: 16px 28px; }

  .fact-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    padding: 60px 28px;
    color: #a0aec0;
    font-size: 15px;
  }

  .fact-check-cell {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .fact-row {
    display: grid;
    grid-template-columns: 36px 2fr 1.2fr 1.2fr 1fr 1fr 80px;
    align-items: center;
    padding: 14px 28px;
    border-bottom: 1px solid #f1f4f9;
    transition: background 0.15s;
    &:hover { background: #f7f9ff; }
    &.fact-row-alt { background: #fafbfd; &:hover { background: #f0f4ff; } }
    &.fact-row-sel { background: #eef3ff !important; }
    @media (max-width: 700px) {
      grid-template-columns: 1fr 1fr;
      gap: 8px;
      padding: 14px 16px;
    }
  }

  .fact-cell {
    display: flex;
    flex-direction: column;
    gap: 2px;
    .fact-label { display: none; font-size: 10px; color: #a0aec0; font-weight: 600; text-transform: uppercase; @media (max-width: 700px) { display: block; } }
  }
  .fact-cell-action { align-items: flex-end; @media (max-width: 700px) { grid-column: span 2; align-items: flex-start; } }

  .fact-nro { font-size: 14px; font-weight: 700; color: #1a202c; }
  .fact-saldo-pendiente { font-size: 14px; font-weight: 700; color: #e53e3e; }
  .fact-saldo-ok { font-size: 14px; color: #38a169; font-weight: 600; }
  .fact-total { font-size: 14px; font-weight: 600; color: #2d3748; }

  .fact-load-more {
    display: flex;
    justify-content: center;
    padding: 24px;
  }

  .fact-tabs {
    border-bottom: 1px solid #eef0f4;
    margin: 0;
  }

  // Calendario
  .fact-cal-wrap { padding: 24px 28px; }
  .fact-cal-header {
    display: flex;
    align-items: center;
    gap: 4px;
    margin-bottom: 20px;
    .fact-cal-title { font-size: 18px; font-weight: 700; color: #1a202c; flex: 1; text-align: center; }
  }
  .fact-cal-grid {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 4px;
  }
  .fact-cal-dow {
    text-align: center;
    font-size: 11px;
    font-weight: 700;
    color: #a0aec0;
    text-transform: uppercase;
    padding: 6px 0;
  }
  .fact-cal-cell {
    min-height: 80px;
    border-radius: 8px;
    border: 1px solid #eef0f4;
    padding: 6px;
    background: white;
    position: relative;
    &.fact-cal-empty { background: transparent; border-color: transparent; }
    &.fact-cal-today {
      border-color: #0F4DFF;
      background: #f0f4ff;
      .fact-cal-day { color: #0F4DFF; font-weight: 800; }
    }
    &.fact-cal-has { background: #fff8f8; border-color: #ffc5c5; }
  }
  .fact-cal-day { font-size: 13px; font-weight: 600; color: #4a5568; display: block; margin-bottom: 4px; }
  .fact-cal-event {
    background: #e53e3e;
    border-radius: 4px;
    padding: 3px 6px;
    margin-bottom: 3px;
    cursor: pointer;
    &:hover { background: #c53030; }
    .fact-cal-event-nro { display: block; font-size: 10px; color: white; font-weight: 700; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
    .fact-cal-event-saldo { display: block; font-size: 11px; color: rgba(255,255,255,0.9); font-weight: 600; }
  }
  @media (max-width: 600px) {
    .fact-cal-cell { min-height: 56px; padding: 4px; }
    .fact-cal-event-nro { display: none; }
  }

  .fact-loading-overlay {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    color: white;
    font-size: 15px;
  }
}
</style>
